export const SHOPIFY_API_LIBRARY_VERSION = '12.3.0';
